/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_DevelopersInputs */

const en_mk_foot_developers = /** @type {(inputs: Mk_Foot_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developers`)
};

const id_mk_foot_developers = /** @type {(inputs: Mk_Foot_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

/**
* | output |
* | --- |
* | "Developers" |
*
* @param {Mk_Foot_DevelopersInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_developers = /** @type {((inputs?: Mk_Foot_DevelopersInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_DevelopersInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_developers(inputs)
	return en_mk_foot_developers(inputs)
});